<template>
  <div>
    <STooltip placement="bottom">
      <template #tooltip-trigger="{ triggerAttrs }">
        <b-button v-bind="triggerAttrs"
                  variant="link"
                  class="d-flex align-items-center text-decoration-none pl-0"
        >
          <span class="text-muted">
            {{
              titleWithoutBranding
                ? $t('login.login_sign_in.new_user_sdui.title_without_branding')
                : $t('login.login_sign_in.new_user_sdui.title')
            }}
          </span>
          <sdui-icon class="icon-info ml-1 text-muted" />
        </b-button>
      </template>

      <template #tooltip-text>
        <div class="small mb-2">
          {{ $t('login.login_sign_in.new_user_sdui.tooltip.description1') }}
        </div>

        <div class="small">
          {{ $t('login.login_sign_in.new_user_sdui.tooltip.description2') }}
        </div>
      </template>
    </STooltip>

    <b-button
      data-cy="registerNew"
      class="new-to-app-wrapper mb-3 reset-button"
      variant="transparent"
      @click="redirectToRegistrationAndTrack"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center justify-content-between">
          <img
            src="/brandings/default/login/sdui-activation-code.png"
            alt=""
            class="object-scale primary-svg-filter mt-3 pt-1"
            :data-cy="`${branding}-logo`"
            loading="lazy"
          />
          <div class="info-wrapper">
            <p class="title font-weight-bold mb-0">{{ $t('login.login_sign_in.new_account.title') }}</p>
            <p class="description text-muted mb-0">{{ $t('login.login_sign_in.new_account.description') }}</p>
          </div>
        </div>
        <sdui-icon class="icon-chevron-right text-muted" />
      </div>
    </b-button>
  </div>
</template>

<script>
import brandingMixin from 'src/mixins/branding/brandingMixin.js'
import STooltip from 'src/components/base/STooltip.vue'

export default {
  name: 'LoginRegisterByActivationCode',
  components: {
    STooltip,
  },

  mixins: [brandingMixin],
  props: {
    titleWithoutBranding: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    redirectToRegistrationAndTrack() {
      this.$router.push({ name: 'register-activation-key-no-redirect', params: { code: 'null' } })
    }
  }
}
</script>

<style scoped lang="scss">
.new-to-app-wrapper {
  border: 1px solid $color-gray-100;
  user-select: none;
  border-radius: 5px;

  img {
    height: 88px;
  }

  .info-wrapper {
    padding: 10px 0;
    .title {
      font-size: pxtorem(18);
    }
    .description {
      font-size: pxtorem(15);
    }
  }

  .icon {
    font-size: pxtorem(18);
  }
}
.icon-info {
  position: relative;
  bottom: 2px;
}
.reset-button {
  padding-right: 12px !important;
  width: 100%;
}
</style>
